import { render, staticRenderFns } from "./SmsSub.vue?vue&type=template&id=dd33bcc4"
import script from "./SmsSub.vue?vue&type=script&lang=js"
export * from "./SmsSub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports